"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const acoCountyMarketShare = {
    name: 'aco-county-market-share',
    tableType: 'composite',
    grain: [
        'aco::id',
    ],
    joins: [
        'zip-geo:fips',
    ],
    tableGrain: [
        '!aco',
        'year',
    ],
    foreignKeys: [
        'aco::id',
    ],
};
const providerClinicGroup = {
    name: 'provider-clinic-group',
    tableType: 'composite',
    grain: [
        'provider::id',
        'provider-group::id',
        'clinic::id::clinic_npi',
    ],
    tableGrain: [
        '!provider'
    ],
    foreignKeys: [
        'provider::id',
        'provider-group::id',
        'clinic_npi:clinic::id',
    ],
    facts: [
        // Provider
        'geriatrician-volume',
        'physician-performance',
        'provider-mips-performance',
        'provider-ncqa-program-recognition-current',
        'provider-other-supplier-volume',
        // Provider group
        'physician-group-patient-experience',
        'physician-group-performance',
        'provider-group-census',
        'provider-group-ehr-vendor-penetration',
        'provider-group-mips-performance',
        'provider-group-specialties',
    ],
};
const providerClinicGroupFull = {
    name: 'provider-clinic-group-full',
    tableType: 'composite',
    grain: [
        'provider::id',
        'provider-group::id',
        'clinic::id::clinic_npi',
    ],
    tableGrain: [
        '!provider',
        'year_key'
    ],
    foreignKeys: [
        'provider::id',
        'provider-group::id',
        'clinic_npi:clinic::id',
    ],
    facts: [
        // Provider
        'geriatrician-volume',
        'physician-performance',
        'provider-mips-performance',
        'provider-ncqa-program-recognition-current',
        'provider-other-supplier-volume',
        // Provider group
        'physician-group-patient-experience',
        'physician-group-performance',
        'provider-group-census',
        'provider-group-ehr-vendor-penetration',
        'provider-group-mips-performance',
        'provider-group-specialties',
    ],
};
const providerIndex = {
    name: 'provider-index',
    tableType: 'dim',
    grain: ['provider::key'],
    tableGrain: ['!provider'],
    foreignKeys: [],
    facts: [],
};
const providerRisk = {
    name: 'provider-risk',
    tableType: 'fact',
    grain: [
        'provider::key',
    ],
    tableGrain: [
        '!provider',
    ],
    foreignKeys: [
        'provider::key'
    ],
};
const hhaDirectory = {
    name: 'home-health-agency-directory',
    tableType: 'composite',
    grain: [
        'facility::id::agency_torch_facility_id',
        'facility::id::complex_torch_facility_id',
        'health-system::id',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'agency_torch_facility_id:facility::id',
        'complex_torch_facility_id:facility::id',
        'health-system::id',
    ],
    facts: [
        '@hha',
        '!health-system',
    ]
};
const hospiceDirectory = {
    name: 'hospice-directory',
    tableType: 'composite',
    grain: [
        'facility::id',
        'health-system::id',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key'
    ],
    foreignKeys: [
        'facility::id',
        'affiliated_torch_facility_id:facility::id',
        'health-system::id',
    ],
    facts: [
        '@hospice',
        '!health-system',
    ]
};
const maScorecard = {
    name: 'ma-scorecard',
    tableType: 'composite',
    grain: [
        'facility::id'
    ],
    tableGrain: [
        '!facility'
    ],
    foreignKeys: [
        'facility::id'
    ]
};
const hospitalDirectory = {
    name: 'hospital-directory',
    tableType: 'dim',
    idField: 'torch_facility_id',
    keyField: 'facility_dim_key',
    grain: [
        'facility::key',
        'facility::id',
        'year::key',
    ],
    tableGrain: [
        '!facility',
    ],
    foreignKeys: [
        'facility::id',
        'facility::key',
    ],
    facts: [
        '@hospital',
        '~hospital-pricing',
        '~hospital-pricing-relativity-medicare-hcg-service'
    ],
};
const facilityDirectory = {
    name: 'facility-directory',
    tableType: 'dim',
    idField: 'torch_facility_id',
    keyField: 'facility_dim_key',
    grain: [
        'facility::key',
        'facility::id',
        'year::key',
    ],
    tableGrain: [
        '!facility',
    ],
    foreignKeys: [
        'facility::id',
        'facility::key',
    ],
    facts: [
        '~hospital-pricing',
        '~hospital-pricing-relativity-medicare-hcg-service'
    ],
};
const acoDirectory = {
    name: 'aco-directory',
    tableType: 'composite',
    idField: 'torch_aco_id',
    grain: [
        'aco::id::torch_aco_id',
    ],
    tableGrain: [
        '!aco'
    ],
    foreignKeys: [
        'aco::id',
    ],
};
const cbsaLatest = {
    name: 'cbsa-latest',
    tableType: 'dim',
    keyField: 'cbsa_dim_key',
    grain: [],
    tableGrain: ['!cbsa'],
    foreignKeys: [],
    facts: [
        'cbsa-age-sex',
        'cbsa-census',
        'cbsa-financial',
        'cbsa-pophealth',
        'cbsa-race-ethnicity',
        'cbsa-market-concentration',
    ]
};
const countyLatest = {
    name: 'county-latest',
    tableType: 'dim',
    keyField: 'county_dim_key',
    grain: [],
    tableGrain: ['!county'],
    foreignKeys: [],
    facts: [
        'county-age-sex',
        'county-census',
        'county-financial',
        'county-pophealth',
        'county-race-ethnicity',
        'county-market-concentration',
        'medicare-geographic-variation',
        'apm-metrics',
    ]
};
const pshpDirectory = {
    name: 'pshp-directory',
    tableType: 'composite',
    grain: [
        'health-system::id',
        'payer::id',
        'payer-group::id',
        'year::key',
    ],
    tableGrain: [
        '!health-system',
        '!payer',
        'year_key',
    ],
    foreignKeys: [
        'health-system::id',
        'payer::id',
        'payer-group::id',
    ],
};
const npiFacilityCrosswalk = {
    name: 'npi-facility-crosswalk',
    tableType: 'composite',
    grain: [
        'npi',
        'facility::id',
    ],
    tableGrain: [
        '!npi',
        '!facility',
    ],
    foreignKeys: [
        'npi::id',
        'facility::id',
    ]
};
const snfDirectory = {
    name: 'snf-directory',
    tableType: 'composite',
    grain: [
        'facility::id',
        'health-system::id'
    ],
    tableGrain: ['!facility'],
    foreignKeys: [
        'facility::id',
        'affiliated_torch_facility_id:facility::id',
        'health-system::id',
    ],
    facts: [
        '@nursing',
        '!health-system',
    ]
};
const zctaLatest = {
    name: 'zcta-latest',
    tableType: 'dim',
    keyField: 'zcta_dim_key',
    grain: [],
    tableGrain: ['!zcta'],
    foreignKeys: [],
    facts: [
        'zcta-age-sex',
        'zcta-census',
        'zcta-financial',
        'zcta-pophealth',
        'zcta-race-ethnicity',
    ]
};
const acoCBSA = {
    name: 'aco-cbsa',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!aco',
        '!cbsa'
    ],
    foreignKeys: [
        'aco::key',
        'cbsa:cbsa:cbsa'
    ]
};
const acoCounty = {
    name: 'aco-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!aco',
        '!county'
    ],
    foreignKeys: [
        'aco::key',
        'fips:county:fips'
    ]
};
const acoState = {
    name: 'aco-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!aco',
        '!state'
    ],
    foreignKeys: [
        'aco::key',
        'state:state:state'
    ]
};
const healthSystemMarketShareCBSA = {
    name: 'health-system-market-share-cbsa',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!org',
        '!cbsa',
        'year_key'
    ],
    foreignKeys: [
        'cbsa::key',
        'org::id'
    ]
};
const healthSystemMarketShareCounty = {
    name: 'health-system-market-share-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!org',
        '!county',
        'year_key'
    ],
    foreignKeys: [
        'county::key',
        'org::id'
    ]
};
const healthSystemMarketShareState = {
    name: 'health-system-market-share-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!org',
        '!state',
        'year_key'
    ],
    foreignKeys: [
        'state::key',
        'org::id'
    ]
};
const raceEthnicityProportionsCBSA = {
    name: 'race-ethnicity-proportions-cbsa',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!cbsa',
        'year_key'
    ],
    foreignKeys: [
        'cbsa::key'
    ]
};
const raceEthnicityProportionsCounty = {
    name: 'race-ethnicity-proportions-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!county',
        'year_key'
    ],
    foreignKeys: [
        'county::key'
    ]
};
const raceEthnicityProportionsState = {
    name: 'race-ethnicity-proportions-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!state',
        'year_key'
    ],
    foreignKeys: [
        'state::key'
    ]
};
const maContractPlanTypeCBSA = {
    name: 'ma-contract-plan-type-cbsa',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer',
        '!payer-group',
        '!cbsa',
        'contract_id',
        'plan_type',
        'year_month_key'
    ],
    foreignKeys: [
        'payer::key',
        'payer-group::key',
        'cbsa::key'
    ]
};
const maContractPlanTypeState = {
    name: 'ma-contract-plan-type-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer',
        '!payer-group',
        '!state',
        'contract_id',
        'plan_type',
        'year_month_key'
    ],
    foreignKeys: [
        'payer::key',
        'payer-group::key',
        'state::key'
    ]
};
const maContractPlanTypeCounty = {
    name: 'ma-contract-plan-type-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer',
        '!payer-group',
        '!county',
        'contract_id',
        'plan_type',
        'year_month_key'
    ],
    foreignKeys: [
        'payer::key',
        'payer-group::key',
        'county::key'
    ]
};
const maPayerGroupCBSA = {
    name: 'ma-payer-group-cbsa',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer-group',
        '!cbsa',
        'year_month_key'
    ],
    foreignKeys: [
        'payer-group::key',
        'cbsa::key'
    ]
};
const maPayerGroupCounty = {
    name: 'ma-payer-group-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer-group',
        '!county',
        'year_month_key'
    ],
    foreignKeys: [
        'payer-group::key',
        'county::key'
    ]
};
const maPayerGroupState = {
    name: 'ma-payer-group-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer-group',
        '!state',
        'year_month_key'
    ],
    foreignKeys: [
        'payer-group::key',
        'state::key'
    ]
};
const maPayerSubsidiaryCounty = {
    name: 'ma-payer-subsidiary-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer',
        '!county',
        '!state',
        'latest_year_month_key'
    ],
    foreignKeys: [
        'payer::key',
        'county::key',
        'state::key'
    ]
};
const payerSummaryIndex = {
    name: 'payer-summary-index',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer',
        'year_key'
    ],
    foreignKeys: [
        'payer::key'
    ]
};
const payerGroupSummaryIndex = {
    name: 'payer-group-summary-index',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!payer-group',
        'year_key'
    ],
    foreignKeys: [
        'payer-group::key'
    ]
};
const hospitalMarketShareCBSA = {
    name: 'hospital-market-share-cbsa',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!facility',
        '!cbsa',
        'year_key'
    ],
    foreignKeys: [
        'cbsa::key',
        'facility::id'
    ]
};
const hospitalMarketShareCounty = {
    name: 'hospital-market-share-county',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!facility',
        '!county',
        'year_key'
    ],
    foreignKeys: [
        'county::key',
        'facility::id'
    ]
};
const hospitalMarketShareState = {
    name: 'hospital-market-share-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!facility',
        '!state',
        'year_key'
    ],
    foreignKeys: [
        'state::key',
        'facility::id'
    ]
};
const facilityFullOwnershipLineage = {
    name: 'facility-full-ownership-lineage',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!health-system',
        '!facility',
    ],
    foreignKeys: [
        'facility::id',
        'torch_health_system_id:health-system:reference_torch_health_system_id',
        'torch_health_system_id:health-system:torch_health_system_id_1',
        'torch_health_system_id:health-system:torch_health_system_id_2',
        'torch_health_system_id:health-system:torch_health_system_id_3',
        'torch_health_system_id:health-system:torch_health_system_id_4',
        'torch_health_system_id:health-system:torch_health_system_id_5',
        'torch_health_system_id:health-system:torch_health_system_id_6',
        'torch_health_system_id:health-system:ultimate_owner_torch_health_system_id',
    ]
};
const healthSystemFullOwnershipLineage = {
    name: 'health-system-full-ownership-lineage',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!health-system',
        'related_torch_health_system_id'
    ],
    foreignKeys: [
        'torch_health_system_id:health-system:reference_torch_health_system_id',
        'torch_health_system_id:health-system:related_torch_health_system_id'
    ]
};
exports.default = [
    acoCountyMarketShare,
    acoDirectory,
    cbsaLatest,
    countyLatest,
    providerClinicGroup,
    providerClinicGroupFull,
    providerIndex,
    providerRisk,
    hhaDirectory,
    maScorecard,
    hospiceDirectory,
    hospitalDirectory,
    facilityDirectory,
    pshpDirectory,
    npiFacilityCrosswalk,
    snfDirectory,
    zctaLatest,
    acoCBSA,
    acoCounty,
    acoState,
    healthSystemMarketShareCBSA,
    healthSystemMarketShareCounty,
    healthSystemMarketShareState,
    raceEthnicityProportionsCBSA,
    raceEthnicityProportionsCounty,
    raceEthnicityProportionsState,
    maContractPlanTypeCBSA,
    maContractPlanTypeCounty,
    maContractPlanTypeState,
    maPayerGroupCBSA,
    maPayerGroupCounty,
    maPayerGroupState,
    maPayerSubsidiaryCounty,
    payerSummaryIndex,
    payerGroupSummaryIndex,
    hospitalMarketShareCBSA,
    hospitalMarketShareCounty,
    hospitalMarketShareState,
    facilityFullOwnershipLineage,
    healthSystemFullOwnershipLineage,
];
